/**
 * Titre des colonnes de notre tableau.
 */
export const utilisateursTableauHeader = [
  {
    id: 'numAdherent',
    libelle: 'Administrateurs',
    isTriable: true,
  },
  {
    id: 'nom',
    libelle: 'Nom',
    isTriable: true,
  },
  {
    id: 'prenom',
    libelle: 'Prénom',
    isTriable: true,
  },
  {
    id: 'email',
    libelle: 'Email',
    isTriable: false,
  },
  {
    id: 'fonction',
    libelle: 'Fonction',
    isTriable: true,
  },
  {
    id: 'profil',
    libelle: 'Profil',
    isTriable: true,
  },
  {
    id: 'statut',
    libelle: 'Actif',
    isTriable: false,
  },
];
/**
 * Titre des colonnes de notre tableau.
 */
export const utilisateursBesseTableauHeader = [
  {
    id: 'nom',
    libelle: 'Nom',
    isTriable: true,
  },
  {
    id: 'prenom',
    libelle: 'Prenom',
    isTriable: true,
  },
  {
    id: 'email',
    libelle: 'Email',
    isTriable: false,
  },
  {
    id: 'profil',
    libelle: 'Profil',
    isTriable: true,
  },
  {
    id: 'statut',
    libelle: 'Actif',
    isTriable: false,
  },
];
